import { isVictorCorthals } from '../lib/specialCases.js';

function escapeHtml(s) {
  return s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}

function formatDate(ts) {
  const d = ts ? new Date(ts * 1000) : new Date();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${mm}.${dd}.${d.getFullYear()}`;
}

export function renderCertificate(container, { name, caseNumber, createdAt }) {
  const victor = isVictorCorthals(name);
  const titleText = victor ? 'Certificate of Heterosexuality' : 'Certificate of Gayness';
  const titleFill = victor ? '#2d1d05' : 'url(#cert-title-gradient)';
  const emphasisText = victor ? 'one hundred percent NOT gay' : 'one hundred percent gay';
  const sealTick = victor ? '✗' : '✓';
  const sealFill = victor ? 'url(#seal-mono)' : 'url(#seal-rainbow)';
  const voidStamp = victor ? `
        <svg class="cert-void" viewBox="0 0 520 120" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
          <rect x="8" y="8" width="504" height="104" rx="6" fill="none" stroke="#a92020" stroke-width="3" opacity="0.55"/>
          <rect x="18" y="18" width="484" height="84" rx="3" fill="none" stroke="#a92020" stroke-width="1.5" opacity="0.55"/>
          <text x="50%" y="54%" text-anchor="middle" dominant-baseline="middle" font-family="'Cormorant Garamond', Georgia, serif" font-weight="700" font-size="64" letter-spacing="8" fill="#a92020" opacity="0.62">NOT GAY</text>
        </svg>` : '';
  container.innerHTML = `
    <div class="cert-wrap">
      <div class="certificate${victor ? ' certificate--victor' : ''}" data-test="certificate" data-cert-name="${escapeHtml(name)}">
        <div class="cert-inner-border"></div>

        <svg class="cert-corner cert-corner-tl" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2 2 H 14 M 2 2 V 14 M 6 2 Q 10 6 14 2 M 2 6 Q 6 10 2 14" stroke="#8b6f3a" stroke-width="1" fill="none"/>
          <circle cx="2" cy="2" r="1.5" fill="#8b6f3a"/>
        </svg>
        <svg class="cert-corner cert-corner-tr" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M30 2 H 18 M 30 2 V 14 M 26 2 Q 22 6 18 2 M 30 6 Q 26 10 30 14" stroke="#8b6f3a" stroke-width="1" fill="none"/>
          <circle cx="30" cy="2" r="1.5" fill="#8b6f3a"/>
        </svg>
        <svg class="cert-corner cert-corner-bl" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2 30 H 14 M 2 30 V 18 M 6 30 Q 10 26 14 30 M 2 26 Q 6 22 2 18" stroke="#8b6f3a" stroke-width="1" fill="none"/>
          <circle cx="2" cy="30" r="1.5" fill="#8b6f3a"/>
        </svg>
        <svg class="cert-corner cert-corner-br" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M30 30 H 18 M 30 30 V 18 M 26 30 Q 22 26 18 30 M 30 26 Q 26 22 30 18" stroke="#8b6f3a" stroke-width="1" fill="none"/>
          <circle cx="30" cy="30" r="1.5" fill="#8b6f3a"/>
        </svg>

        <svg class="cert-star" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M12 2 L14 9 L21 9 L15.5 13 L17.5 20 L12 16 L6.5 20 L8.5 13 L3 9 L10 9 Z" fill="#b8902f" stroke="#8b6f3a" stroke-width="0.5"/>
        </svg>

        <div class="cert-est">EST. MCMLXIX</div>
        <div class="cert-board">THE GAY CERTIFICATION BOARD</div>
        <div class="cert-presents">hereby presents this</div>

        <svg class="cert-title" viewBox="0 0 600 70" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${titleText}">
          <defs>
            <linearGradient id="cert-title-gradient" x1="0" x2="1" y1="0" y2="0">
              <stop offset="0%" stop-color="#e40303"/>
              <stop offset="20%" stop-color="#ff8c00"/>
              <stop offset="40%" stop-color="#ffed00"/>
              <stop offset="60%" stop-color="#008026"/>
              <stop offset="80%" stop-color="#004dff"/>
              <stop offset="100%" stop-color="#750787"/>
            </linearGradient>
          </defs>
          <text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" font-family="'Cormorant Garamond', Georgia, serif" font-weight="700" font-style="italic" font-size="${victor ? 40 : 48}" fill="${titleFill}">${titleText}</text>
        </svg>

        <svg class="cert-divider" viewBox="0 0 220 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <line x1="10" y1="7" x2="90" y2="7" stroke="#8b6f3a" stroke-width="0.8"/>
          <circle cx="100" cy="7" r="1.5" fill="#8b6f3a"/>
          <path d="M105 7 Q 110 3 115 7 Q 110 11 105 7 Z" fill="#8b6f3a"/>
          <circle cx="120" cy="7" r="1.5" fill="#8b6f3a"/>
          <line x1="130" y1="7" x2="210" y2="7" stroke="#8b6f3a" stroke-width="0.8"/>
        </svg>

        <div class="cert-to">is hereby presented to</div>
        <div class="cert-name" data-test="cert-name">${escapeHtml(name)}</div>

        <div class="cert-recognition">in recognition of having been<br />scientifically and irrevocably verified as<br /><span class="cert-emphasis">${emphasisText}</span></div>

        ${voidStamp}

        <div class="cert-signoff">
          <div><div class="cert-line"></div>${formatDate(createdAt)}<div class="cert-sig-label">DATE OF CERTIFICATION</div></div>
          <div><div class="cert-line"></div><span class="cert-sig">Dr. R. Bowman</span><div class="cert-sig-label">BOARD CHAIR</div></div>
        </div>

        <div class="cert-case">CASE FILE №&nbsp;${escapeHtml(caseNumber)}</div>
        <div class="cert-watermark">gaycertification.com</div>

        <svg class="cert-medallion" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <defs>
            <linearGradient id="seal-rainbow" x1="0" x2="1" y1="0" y2="1">
              <stop offset="0%" stop-color="#e40303"/>
              <stop offset="20%" stop-color="#ff8c00"/>
              <stop offset="40%" stop-color="#ffed00"/>
              <stop offset="60%" stop-color="#008026"/>
              <stop offset="80%" stop-color="#004dff"/>
              <stop offset="100%" stop-color="#750787"/>
            </linearGradient>
            <linearGradient id="seal-mono" x1="0" x2="1" y1="0" y2="1">
              <stop offset="0%" stop-color="#6b4f1a"/>
              <stop offset="100%" stop-color="#2d1d05"/>
            </linearGradient>
            <radialGradient id="seal-shine" cx="35%" cy="30%" r="60%">
              <stop offset="0%" stop-color="#fff" stop-opacity="0.45"/>
              <stop offset="60%" stop-color="#fff" stop-opacity="0"/>
            </radialGradient>
          </defs>
          <circle cx="40" cy="40" r="38" fill="${sealFill}"/>
          <circle cx="40" cy="40" r="34" fill="none" stroke="#fff" stroke-width="0.6" opacity="0.55"/>
          <circle cx="40" cy="40" r="30" fill="none" stroke="#fff" stroke-width="0.4" opacity="0.35" stroke-dasharray="2 2"/>
          <text x="40" y="49" text-anchor="middle" dominant-baseline="middle" font-family="'Cormorant Garamond', Georgia, serif" font-weight="700" font-size="32" fill="#fff">${sealTick}</text>
          <circle cx="40" cy="40" r="38" fill="url(#seal-shine)"/>
        </svg>
      </div>
      <div class="cert-actions">
        <button class="btn btn-dark" data-test="download-pdf">↓ Download PDF</button>
        <button class="btn btn-dark" data-test="share-image">⤴ Share image</button>
        <button class="btn btn-rainbow" data-test="order-printed">🖼 Order printed &amp; framed</button>
        <button class="btn btn-outline" data-test="certify-friend">🌈 Certify a friend →</button>
      </div>
      <div class="cert-trevor">
        Just here for fun? Same. ❤️
        <a href="https://www.thetrevorproject.org/" target="_blank" rel="noopener" data-test="trevor-link">The Trevor Project</a>
      </div>
    </div>
  `;
}
